export default __webpack_public_path__ + "static/media/opium-copy-link.159a74dd.svg";